var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"member",class:{ empty: _vm.isEmpty }},[_c('div',{staticClass:"container"},[_c('project-member',{staticClass:"text-white",attrs:{"members":_vm.list}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }